import { Separator, Direction } from './Separator.styles'

export { Direction }
export default Separator
